







import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import WingBlank from '../WingBlank/index.vue'
@Component({
  components: {
    WingBlank
  }
})
export default class DialogHead extends Vue {
    /**
     * title 标签名字 默认 `头部标签`
     * icon 显示图标 默认 关闭icon
     * on-close 关闭按钮事件
     */
    @Prop({ default: '头部标签' }) title!: string
    @Prop({ default: 'el-icon-close' }) icon!: string
}
